<template>
	<div>
		<div v-if="clip && clip.meta">
			<k-text-field label="Title" v-model="clip.meta.title" autofocus></k-text-field>
			<k-text-field label="Tags" v-model="clip.meta.tags" v-if="$is_admin()"></k-text-field>

       <k-autocomplete
            v-bind:items="clip_types"
            v-model="clip.meta.clip_type"
            label="Clip type"
            item-text="name"
            item-value="value"
            clearable>
          ></k-autocomplete>

			<k-text-field textarea label="Description" v-model="clip.meta.description" style="width: 100%;"></k-text-field>
			<div>Duration: <span style="font-weight: bold;">{{format_time(clip.end_time - clip.start_time)}}</span></div>
			<k-btn color="success" @click="save">Save</k-btn>
	    <k-btn flat @click="$emit('close')">Close</k-btn>
	</div>
	</div>
</template>

<script>
import ClipModel from '@/models/clip.js'
import { mapMutations } from 'vuex'

export default {
	props: ["uuid", "event-uuid", "in-position", "out-position"],
	data () {
		var ch = this.$cloudserver.channel("events:clip:"+(this.uuid||"create"));
		return {
			ws_channel: ch,
			clip: this.convertClip(ch.data),
      clip_types: [
        {"name": "None", value: "none"},
        {"name": "Highlight 1", value: "highlight1"},
        {"name": "Highlight 2", value: "highlight2"},
        {"name": "Highlight 3", value: "highlight3"},
        {"name": "Highlight 4", value: "highlight4"},
        {"name": "Highlight 5", value: "highlight5"}
      ]
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.clip = this.convertClip(newVal);
					if (typeof(this.inPosition) != "undefined") {
						this.clip.start_time = Math.floor(this.inPosition);
					}
					if (typeof(this.outPosition) != "undefined") {
						this.clip.end_time = Math.ceil(this.outPosition);
					}
				}
			},
			deep: true
		}
	},
	computed: {
	},
	methods: {
    convertClip(newVal) {
      console.log("CONVERT CLIP", newVal);  
      var clip = undefined;
      if (Array.isArray(newVal)) {
        new_clip = _.find(newVal, function(v) {
          return v.uuid == this.uuid;
        })
        if (typeof(new_clip) == "undefined" || new_clip == null) new_clip = newVal[0];
        clip = _.cloneDeep(new_clip);
      } else {
        clip = _.cloneDeep(newVal);
      }
      return clip;
    },
		save () {
			var self = this;

			var clip = _.cloneDeep(this.clip);

			if (typeof(this.eventUuid) != "undefined") {
				clip.event_uuid = this.eventUuid;
			}

			this.ws_channel.save({"clip": clip})
				.then((msg) => {
					if (typeof(self.uuid) == "undefined") {
						self.$message.success("Clip was created!");
            var uuids = _.map(msg.data, (quality) => {
              return quality.uuid;
            });
            this.add_process({type: "cloudrec", event: "create-clip", description: "Create clip "+clip.meta.title, meta: {uuids: uuids, event_uuid: this.eventUuid}});
					} else {
						self.$message.success("Clip was updated!");
					}
					this.$emit("save");
				})
				.catch((msg) => {
					if (typeof(self.id) == "undefined") {
						self.$message.warning("Unable to create clip!");
					} else {
						self.$message.warning("Unable to update clip!");
					}
				});
		},
		format_time (time, paddedHours) {
		  time = time * 1000
  		time = parseInt(time/1000)
  		const seconds = time % 60
  		time = parseInt(time/60)
  		const minutes = time % 60
  		time = parseInt(time/60)
  		const hours = time % 24
  		const days = parseInt(time/24)
  		let out = ''
  		if (days && days > 0) {
    		out += days + ':'
    		if (hours < 1) out += '00:'
  		}
  		if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':'
  		out += ('0' + minutes).slice(-2) + ':'
  		out += ('0' + seconds).slice(-2)
  		return out.trim()
		},
		...mapMutations({add_process: 'processes/add'})
	},
	mounted () {
		this.ws_channel.join();
	}
}
</script>
